import React, { ReactNode } from 'react'

import './SectionHeader.css'

type Props = {
  title: string
  action?: ReactNode
}

export const SectionHeader = ({ title, action }: Props) => {
  return (
    <div className="will-filter-section-header">
      <h3 className="will-filter-section-title">{title}</h3>
      {action && <div className="will-filter-section-action">{action}</div>}
    </div>
  )
}
